import {
    CustomerPaymentAccountDetailContract,
    CustomerLookupContract,
} from 'models'
import usePaymentContext from '../../hook/usePaymentContext'
import { useCustomerAccountPayment } from './useCustomerAccountPayment'
import CustomerAccountPaymentDialogContent from 'components/QuickSaleMobile/Dialog/PaymentDialogMobile/CustomerAccount/CustomerAccountPaymentMobileDialog'
import PaymentAppbar from 'components/QuickSaleMobile/Dialog/PaymentDialogMobile/PaymentAppbar'
import { useCallback } from 'react'

export interface CustomerAccountPaymentModel
    extends CustomerPaymentAccountDetailContract {
    customer?: CustomerLookupContract
}

function CustomerAccountsPaymentContainerMobile({
    onBack,
}: {
    onBack?: () => void
}) {
    const {
        paymentAccounts,
        onSelectCustomerAccount,
        onCloseAccountDialog,
        orderCustomerID,
        customerList,
        onSelectedPaymentCustomerID,
        selectedCustomerAccount,
        loadingCustomerPaymentAccount,
    } = usePaymentContext()
    const {
        onAssignToPayment,
        selectedCustomer,
        popupSelectCustomerId,
        setPopupSelectCustomerID,
        customerAccounts,
    } = useCustomerAccountPayment({
        selectedCustomerId:
            selectedCustomerAccount?.customer?.customerID ?? orderCustomerID,
        customerList,
        paymentAccounts,
        onSelectCustomerAccount,
        onCloseAccountDialog,
    })
    const handleSelectCustomer = useCallback(
        (customerId: string) => {
            setPopupSelectCustomerID(customerId)
            onSelectedPaymentCustomerID(customerId)
        },
        [onSelectedPaymentCustomerID, setPopupSelectCustomerID],
    )
    const onClickBack = useCallback(() => {
        onCloseAccountDialog()
        onBack?.()
    }, [onBack, onCloseAccountDialog])

    return (
        <>
            <PaymentAppbar onBack={onClickBack} />
            <CustomerAccountPaymentDialogContent
                onCloseAccountDialog={onClickBack}
                customerAccounts={customerAccounts}
                popupSelectCustomerId={popupSelectCustomerId}
                handleSelectCustomer={handleSelectCustomer}
                onAssignToPayment={onAssignToPayment}
                selectedCustomer={selectedCustomer}
                isLoading={loadingCustomerPaymentAccount}
            />
        </>
    )
}

export default CustomerAccountsPaymentContainerMobile
